<div
  class="form-group 2xl:!block"
  [ngClass]="{ 'rounded-none shadow-none space-y-2': reviewMode }"
  id="contacts-section"
>
  <div class="form-header 2xl:!w-full 2xl:!border-b 2xl:!border-r-0">
    <div class="flex items-start gap-2 flex-wrap">
      <div class="flex gap-2 items-center">
        <div class="bg-turquoise-bright/15 size-10 flex justify-center items-center rounded shrink-0">
          <ion-icon name="person-add-outline" class="size-6 text-turquoise-bright mt-0.5"></ion-icon>
        </div>
        <div class="flex flex-col">
          <span>Contacts &amp; Role Assignment</span>
          <span class="text-grey-mid text-xs font-normal">
            {{ contactRequirementsByGroupType.description }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="form-body 2xl:!w-full">
    <div class="rounded border border-grey-concrete overflow-hidden bg-white">
      <div class="grid lg:grid-cols-12 items-stretch gap-0">
        <div class="lg:col-span-8 xl:col-span-8 min-w-0">
          <div id="allContacts" class="default-grid !shadow-none !m-0 !rounded-none !border-0 h-full">
            <div class="grid-header lg:grid-cols-[2.5fr_2fr_2fr_3.5rem] text-black">
              <div class="grid-header-item cursor-default text-grey-mid">Contact</div>
              <div class="grid-header-item cursor-default text-grey-mid justify-start">Contact Details</div>
              <div class="grid-header-item cursor-default text-grey-mid justify-start">Roles</div>
              <div class="grid-header-item cursor-default"></div>
            </div>
            <div class="grid-body border-b-0">
              @for (contactForm of contactFormGroups$ | async; track $index; let index = $index) {
                <app-contact-item
                  [groupType]="groupType"
                  [contactForm]="contactForm"
                  [contactIndex]="index"
                  [country]="country"
                  [errors]="errors"
                  [formSubmitted]="formSubmitted"
                  (editContact)="addEditContact(contactForm)"
                  (resendEmailConfirmation)="resendEmailConfirmation.emit($event)"
                ></app-contact-item>
              }
              @if ((contactFormGroups$ | async)?.length === 0) {
                <div class="p-6 flex flex-col items-center justify-center text-grey-mid gap-1 min-h-32">
                  <ion-icon name="people-outline" class="size-6"></ion-icon>
                  <span class="text-sm">No contacts added yet</span>
                  @if (groupEdit || formSubmitted) {
                    <span class="text-bright-crimson text-xs flex items-center gap-1">
                      <ion-icon name="alert-circle" class="size-4"></ion-icon>
                      Please add at least one contact.
                    </span>
                  }
                </div>
              }
            </div>
            <div class="border-t border-b border-grey-concrete px-4 py-3 flex justify-center">
              <button
                id="add-contact"
                [disabled]="contactForms.disabled"
                class="btn-primary text-sm py-2 px-4 flex items-center gap-2"
                (click)="addContactFromHeader()"
              >
                <ion-icon class="size-4.5" name="add"></ion-icon>
                <span>{{ (contactFormGroups$ | async)?.length ? 'Add Another Contact' : 'Add Contact' }}</span>
              </button>
            </div>
          </div>
        </div>

        <app-contact-roles-container
          class="lg:col-span-4 xl:col-span-4 min-w-0 border-t border-grey-concrete lg:border-t-0 lg:border-l bg-grey-light-concrete"
          [groupType]="groupType"
          [parentGroupType]="parentGroupType"
          [contactFormGroups]="contactFormGroups$ | async"
          [contactsFormArray]="contactsFormArray"
          [requiredRoleUnassigned]="requiredRoleUnassigned"
          [groupEdit]="groupEdit"
          [formSubmitted]="formSubmitted"
          [reviewMode]="reviewMode"
          (addEditContact)="addEditContact($event)"
          (updateAllCustomers)="updateAllCustomers.emit()"
        ></app-contact-roles-container>
      </div>
    </div>
  </div>
</div>
